import { Box, Stack } from "@chakra-ui/react";
import colors from "app/colors";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import React, { memo, useMemo } from "react";
import QuotedMessage from "../messages/quoted-message";
import { FORWARD_DRAFT_ID } from "modules/utils/Constants";

interface IProps {
  draftId: string;
}

const ComposeQuotedMessageList = ({ draftId }: IProps) => {
  const { draft, clearQuotedMessage } = useMessageThreadDraft({ draftId });
  const quotedMessages = draft?.quotedMessageList;

  const maxLines = useMemo(() => {
    if (draft?.draftType === "reply" && draft?.id !== FORWARD_DRAFT_ID) {
      return 2;
    }
    return undefined;
  }, [draft?.draftType, draft?.id]);

  if (!quotedMessages || quotedMessages.length === 0) {
    return null;
  }

  return (
    <Stack
      bg={colors.whiteTertiary}
      w="full"
      overflowY="auto"
      mt={3}
      p={2}
      rounded="md"
      spacing={4}
    >
      {quotedMessages.map((quotedMessage) => {
        const onClose = async () => {
          clearQuotedMessage(quotedMessage.messageId);
        };

        return (
          <Box key={quotedMessage.messageId}>
            <QuotedMessage
              quotedMessage={quotedMessage}
              onClose={onClose}
              maxLines={maxLines}
            />
          </Box>
        );
      })}
    </Stack>
  );
};

export default memo(ComposeQuotedMessageList);
